import { isRejectedWithValue, type Middleware } from "@reduxjs/toolkit";
import { pushConsoleEntry } from "./errorReport";

interface RequestMeta {
  baseQueryMeta?: { request?: Request };
}

export const apiErrorLogger: Middleware = function apiErrorLogger() {
  return (next) => (action) => {
    if (isRejectedWithValue(action)) {
      const request = (action.meta as RequestMeta).baseQueryMeta?.request;
      pushConsoleEntry("error", ["API", request ? `${request.method} ${request.url}` : "", action.payload]);
    }
    return next(action);
  };
};
